import { useState, useMemo } from 'react';
import { format, startOfMonth, endOfMonth, isValid } from 'date-fns';
import useSessionDates from './useSessionDates';

const useSessionDatesForMonth = (initialDate) => {
    const parsedDate = isValid(new Date(initialDate)) ? new Date(initialDate) : new Date();

    const [visibleMonth, setVisibleMonth] = useState(parsedDate);

    const from = useMemo(() => format(startOfMonth(visibleMonth), 'yyyy-MM-dd'), [visibleMonth]);

    const to = useMemo(() => format(endOfMonth(visibleMonth), 'yyyy-MM-dd'), [visibleMonth]);

    const { data, isLoading, isError, error } = useSessionDates(from, to);

    return {
        sessionDates: data ?? [],
        isLoading,
        isError,
        error,
        visibleMonth,
        setVisibleMonth
    };
};

export default useSessionDatesForMonth;
